import type {
  ExtractData,
  ScoreLabelType,
} from "./types/types";
import { percentageFormatter } from "../../shared/utils";
import { ExtractCallout } from "./ExtractCallout";
import { useSelectVehicleStore } from "../../services/selectVehicleSlice";
import { SelectedVehicle } from "../../shared/models/SelectedVehicle";

type ExtractCalloutsProps = {
  weightedScore: ExtractData["weightedScore"];
  scoreLabel: ExtractData["scoreLabel"];
  normalizedScore: ExtractData["normalizedScore"];
};

export function ExtractCallouts({
  weightedScore,
  normalizedScore,
  scoreLabel,
}: ExtractCalloutsProps) {

  const { selectedVehicle } = useSelectVehicleStore();
  const scorePercentage = normalizedScore / 1000;
  let scoreLabelPerPercentage;

  if((scorePercentage*100) === 100){
    scoreLabelPerPercentage = "PERFECT";
  }else if((scorePercentage*100) >= 90){
    scoreLabelPerPercentage = "VERY_HIGH";
  }else if((scorePercentage*100) >= 50){
    scoreLabelPerPercentage = "REGULAR";
  }else if((scorePercentage*100) >= 1){
    scoreLabelPerPercentage = "DEFICIENT";
  }else{
    scoreLabelPerPercentage = "VERY_DEFICIENT";
  }

  return (
    <div className="display-grid grid-cols-1 cq-700:grid-cols-1">
      <ExtractCallout
        icon={getIcon(scoreLabelPerPercentage as ScoreLabelType)}
        variant={getColorVariant(scoreLabelPerPercentage as ScoreLabelType)}
        title={getTitle(scoreLabelPerPercentage, selectedVehicle.name, scorePercentage)}
      >
        {scoreLabelMap.get(scoreLabelPerPercentage as ScoreLabelType)+" "}
        {scoreLabelDescriptionMap.get(scoreLabelPerPercentage as ScoreLabelType)}
      </ExtractCallout>
    </div>
  );
  
}

const getTitle = (scoreLabel: string, vehicleName: string, score: number) => {

  const scorePercentage = percentageFormatter.format(score);

  switch(scoreLabel){
    case "PERFECT":
      return `Performance perfeita! ${vehicleName} conquistou 100% dos pontos.`
    case "VERY_HIGH":
      return `Ótimo trabalho! A pontuação foi de ${scorePercentage}.`
    case "REGULAR":
      return `Bom trabalho! ${vehicleName} alcançou ${scorePercentage} dos pontos.`
    case "DEFICIENT":
      return `${vehicleName} conquistou ${scorePercentage} dos pontos. `
    case "VERY_DEFICIENT":
      return "A pontuação nesta viagem foi de 0%."
    default:
      return "default"
  }
}

const getIcon = (scoreLabel: ScoreLabelType) => {
  if(["PERFECT", "VERY_HIGH"].includes(scoreLabel)){
    return "rioglyph-check-badge"
  }else if(scoreLabel === "REGULAR"){
    return "rioglyph-ongoing"
  }else{
    return "rioglyph-exclamation-sign"
  }
}

const getColorVariant = (scoreLabel: ScoreLabelType) => {
  switch(scoreLabel){
    case "PERFECT":
      return "custom-primary"
    case "VERY_HIGH":
      return "success"
    case "REGULAR":
      return "custom-gray"
    case "DEFICIENT":
      return "warning"
    case "VERY_DEFICIENT":
      return "danger"
    default:
      return "default"
  }
}

const scoreLabelMap = new Map<ScoreLabelType, string>([
  ["PERFECT", "Parabéns pela condução exemplar!"],
  ["VERY_HIGH", "Falta muito pouco para a excelência!"],
  ["REGULAR", "O veículo está no caminho certo."],
  ["DEFICIENT", "Sempre há espaço para evoluir."],
  ["VERY_DEFICIENT", "Parece que esta viagem não gerou pontos."],
]);

const scoreLabelDescriptionMap = new Map<ScoreLabelType, string>([
  ["PERFECT", "Continue assim para manter o ótimo resultado nas próximas viagens."],
  ["VERY_HIGH", "Confira os últimos detalhes no extrato para chegar a 100%."],
  ["REGULAR", "Analise os pontos de melhoria para se aproximar da pontuação máxima."],
  ["DEFICIENT", "Confira no extrato os principais pontos de melhoria para a próxima viagem."],
  [
    "VERY_DEFICIENT",
    "Analise o extrato para entender os critérios e começar a pontuar na próxima.",
  ],
]);
